import { Form, message } from 'antd'
import { RcFile } from 'antd/lib/upload'
import React, { useEffect, useReducer, useRef, useState } from 'react'
import {
  GET_ACCOUNT_DETAIL,
  AccountDetailRes,
  DOWNLOAD_ZIP_MORE,
  InvoiceParams,
  OrderAccountInvoiceInfoList,
  ACCOUNT_OPEN_INVOICE,
  POST_RECOGNIZE_INVOICE,
  RecognizeInvoiceParams,
  POST_DOWNLOAD_ACCOUNT_ACCEPT_TEMP,
  UPLOAD_FILES,
} from '../../api/orderManage'
import { fileFile } from '../../modules/uploadfiles/hooks'
import {
  accountOpenInvoiceStateDictInvert,
  accountStatusDictInvert,
  signVoucherStateDict,
} from '../../tools/state'
import {
  isResponseCodeSuccess,
  formatTime,
  generateRegExp,
  getPicName,
  generateRandomId,
} from '../../tools/util'
import { useQuery } from '../../tools/utilHooks'
import { produce } from 'immer'
import { history } from '../../redux/store'
import { FinanicialInvoiceType } from './components/financialTicketBatchModal'
import { FINANCIAL_INVOICE_FILE_TYPE } from '.'
import moment from 'moment'
import copy from 'copy-to-clipboard'

export type tabKey = '物料明细' | '订单明细' | '回款明细'

interface paginationOption {
  total: number
  current: number
  pagesize: number
}

interface State {
  checkedRadioKey: tabKey // 当前选中tab的key值
  isTableLoading?: boolean
  detailInfo?: AccountDetailRes
  orderDetail: any // 订单明细
  productDetail: any // 物料明细
  returnDetail: any // 回款明细
  dataSource: any[]
  pagination: paginationOption
  selectedRows: any[]
  invoiceData: any[] // 开票信息
  isPreviewModalVisible: boolean
  previewFileUrl: string
  ticketInfoList: InvoiceParams[]
  editIndex: number
  isSaveButtonLoading: boolean
  invoiceBatchModalVisible: boolean
  finanicialInvoiceType: FinanicialInvoiceType
  batchUploadLoading: boolean
}
type ActionType =
  | 'setCurrentRadioDict'
  | 'setCheckedRadioKey'
  | 'setIsTableLoading'
  | 'setDetailInfo'
  | 'setOrderDetail'
  | 'setProductDetail'
  | 'setReturnDetail'
  | 'setDataSource'
  | 'setPagination'
  | 'setSelectedRows'
  | 'setInvoiceData'
  | 'setIsPreviewModalVisible'
  | 'setPreviewFileUrlUrl'
  | 'setTicketInfoListAction'
  | 'setEditIndexAction'
  | 'setIsSaveButtonLoadingAction'
  | 'setInvoiceBatchModalVisibleAction'
  | 'setFinanicialInvoiceTypeAction'
  | 'setBatchUploadLoadingAction'

interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  checkedRadioKey: '订单明细',
  isTableLoading: false,
  detailInfo: undefined,
  orderDetail: undefined,
  productDetail: undefined,
  returnDetail: undefined,
  dataSource: [],
  pagination: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  selectedRows: [],
  invoiceData: [],
  isPreviewModalVisible: false,
  previewFileUrl: '',
  ticketInfoList: [],
  editIndex: -1,
  isSaveButtonLoading: false,
  invoiceBatchModalVisible: false,
  finanicialInvoiceType: 'batchUpload',
  batchUploadLoading: false,
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setCheckedRadioKey':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setDetailInfo':
      newstate.detailInfo = action.payload
      return newstate
    case 'setOrderDetail':
      newstate.orderDetail = action.payload
      return newstate
    case 'setProductDetail':
      newstate.productDetail = action.payload
      return newstate
    case 'setReturnDetail':
      newstate.returnDetail = action.payload
      return newstate
    case 'setDataSource':
      newstate.dataSource = action.payload
      return newstate
    case 'setPagination':
      newstate.pagination = action.payload
      return newstate
    case 'setSelectedRows':
      newstate.selectedRows = action.payload
      return newstate
    case 'setInvoiceData':
      newstate.invoiceData = action.payload
      return newstate
    case 'setIsPreviewModalVisible':
      newstate.isPreviewModalVisible = action.payload
      return newstate
    case 'setPreviewFileUrlUrl':
      newstate.previewFileUrl = action.payload
      return newstate
    case 'setTicketInfoListAction':
      newstate.ticketInfoList = action.payload
      return newstate
    case 'setEditIndexAction':
      newstate.editIndex = action.payload
      return newstate
    case 'setIsSaveButtonLoadingAction':
      newstate.isSaveButtonLoading = action.payload
      return newstate
    case 'setInvoiceBatchModalVisibleAction':
      newstate.invoiceBatchModalVisible = action.payload
      return newstate
    case 'setFinanicialInvoiceTypeAction':
      newstate.finanicialInvoiceType = action.payload
      return newstate
    case 'setBatchUploadLoadingAction':
      newstate.batchUploadLoading = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
const setCheckedRadioKey = (val: React.Key): Action => ({
  type: 'setCheckedRadioKey',
  payload: val,
})
/**
 * 设置详情页信息对象
 */
const setDetailInfo = (val: any): Action => ({
  type: 'setDetailInfo',
  payload: val,
})

const setTicketInfoListAction = (val: InvoiceParams[]): Action => ({
  type: 'setTicketInfoListAction',
  payload: val,
})

const setEditIndexAction = (val: number): Action => ({
  type: 'setEditIndexAction',
  payload: val,
})

const setIsSaveButtonLoadingAction = (val: boolean): Action => ({
  type: 'setIsSaveButtonLoadingAction',
  payload: val,
})

/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
const setPagination = (val: paginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

/**
 * 设置选中的行的信息列表
 * @param val
 * @returns
 */
const setSelectedRows = (val: any): Action => ({
  type: 'setSelectedRows',
  payload: val,
})

// 预览弹窗
const setIsPreviewModalVisible = (val: boolean): Action => ({
  type: 'setIsPreviewModalVisible',
  payload: val,
})

// 预览文件url
const setPreviewFileUrlUrl = (val: string): Action => ({
  type: 'setPreviewFileUrlUrl',
  payload: val,
})

// 上传发票
const setInvoiceBatchModalVisibleAction = (val: boolean): Action => ({
  type: 'setInvoiceBatchModalVisibleAction',
  payload: val,
})

// 上传发票
const setFinanicialInvoiceTypeAction = (
  val: FinanicialInvoiceType,
): Action => ({
  type: 'setFinanicialInvoiceTypeAction',
  payload: val,
})

// 批量上传loading
const setBatchUploadLoadingAction = (val: boolean): Action => ({
  type: 'setBatchUploadLoadingAction',
  payload: val,
})

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { detailInfo, pagination, ticketInfoList } = state
  const query = useQuery()
  const id = query.get('id') || ''
  const [form] = Form.useForm()
  const [invoiceForm] = Form.useForm()
  const [isAddModalVisible, setIsAddModalVisible] = useState(false)

  const handleCheckedChange = (key: any) => {
    dispatch(setCheckedRadioKey(key))
  }
  const handleTableChangeCheck = (
    selectedRowKeys: any,
    selectedRows: any[],
  ) => {
    dispatch(setSelectedRows(selectedRows))
  }

  function convertAccountDetailState(detail: AccountDetailRes) {
    return {
      ...detail,
      accountStatus: accountStatusDictInvert?.[detail?.accountStatus]?.name,
      // @ts-ignore
      commitTime: formatTime(detail?.commitTime + '' ?? ''),
      confirmTime: formatTime(detail?.confirmTime ?? ''),
      // @ts-ignore
      createTime: formatTime(detail?.createTime + '' ?? ''),
      accountOpenInvoiceStatus:
        accountOpenInvoiceStateDictInvert?.[detail?.accountOpenInvoiceStatus]
          ?.name,

      orderInfoList: detail?.orderInfoList?.map((item) => {
        return {
          ...item,
          id: item.orderId,
          // @ts-ignore
          orderTime: formatTime(item.orderTime + '' ?? ''),
          signVoucherState: (signVoucherStateDict as any)?.[
            item?.signVoucherState
          ],
        }
      }),
    }
  }
  function convertToInvoiceParam(
    list: OrderAccountInvoiceInfoList[],
  ): InvoiceParams[] {
    return list.map((item) => {
      return {
        ...item,
        fileIdList: item.fileList.map((item) => item.id),
        invoiceId: item.accountInvoiceId,
      }
    })
  }
  const getDetailInfo = async () => {
    const res = await GET_ACCOUNT_DETAIL({
      accountId: id,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = convertAccountDetailState(res.data)
      dispatch(setDetailInfo(resData))
      dispatch(
        setTicketInfoListAction(
          convertToInvoiceParam(resData.orderAccountInvoiceInfoList),
        ),
      )
      form.setFieldsValue({
        ...res.data,
      })
    } else {
      message.warning(res.msg)
    }
  }

  function handlePaginationChange(page: number, pageSize?: number) {
    dispatch(
      setPagination({
        ...pagination,
        pagesize: pageSize ? pageSize : pagination.pagesize,
        current: page,
      }),
    )
  }

  const handleAddOrderModalCancel = () => {
    setIsAddModalVisible(false)
  }

  async function refreshPage() {
    getDetailInfo()
  }
  useEffect(() => {
    if (id) {
      getDetailInfo()
    }
    // eslint-disable-next-line
  }, [])

  const handleSumitSuccess = (param: InvoiceParams, index: number) => {
    handleAddOrderModalCancel()
    // getDetailInfo()
    if (index < 0) {
      dispatch(setTicketInfoListAction([...ticketInfoList, param]))
    } else {
      const newState = produce(ticketInfoList, (draftState) => {
        draftState[index] = param
      })
      dispatch(setTicketInfoListAction(newState))
    }
  }

  // 打包下载附件
  const onPackageDownload = async (files: fileFile[]) => {
    await DOWNLOAD_ZIP_MORE({
      fileIdList: files.map((item) => item.id!),
    })
  }

  const cancelPreviewModal = () => {
    dispatch(setIsPreviewModalVisible(false))
  }

  const showPreviewModal = (url: string) => {
    dispatch(setPreviewFileUrlUrl(url))
    dispatch(setIsPreviewModalVisible(true))
  }
  const handleDelTicket = (index: number) => {
    if (index > ticketInfoList.length - 1) {
      return
    }
    const afterDeleted = produce(ticketInfoList, (draftState) => {
      draftState.splice(index, 1)
    })
    dispatch(setTicketInfoListAction(afterDeleted))
  }
  const handleEditTicket = (index: number) => {
    dispatch(setEditIndexAction(index))
    setIsAddModalVisible(true)
  }
  async function handleSaveTicket() {
    if (ticketInfoList.length < 1) {
      message.warning('没有任何发票信息')
      return
    }
    const savedIds: string[] = []
    const savedFileIdsSet = new Set<string>()
    ticketInfoList.forEach((item) => {
      if (item.invoiceId) {
        savedIds.push(item.invoiceId)
      }
      if (item.fileIdList) {
        item.fileIdList.forEach((item) => {
          savedFileIdsSet.add(item)
        })
      }
    })
    const deletedIds = detailInfo?.orderAccountInvoiceInfoList
      .filter((item) => {
        return !savedIds.includes(item.accountInvoiceId)
      })
      .map((item) => item.accountInvoiceId)

    const deletedFileIdsSet = new Set<string>()
    detailInfo?.orderAccountInvoiceInfoList.forEach((item) => {
      item.fileList.forEach((fileItem) => {
        if (!savedFileIdsSet.has(fileItem.id)) {
          deletedFileIdsSet.add(fileItem.id)
        }
      })
    })
    dispatch(setIsSaveButtonLoadingAction(true))
    const res = await ACCOUNT_OPEN_INVOICE({
      deletedFileIds: Array.from(deletedFileIdsSet),
      deletedIds: deletedIds,
      invoiceParams: ticketInfoList.map((item) => {
        return {
          ...item,
          fileIdList: item.fileList.map((item) => item.id),
        }
      }),
      orderAccountId: detailInfo?.id ?? '',
    })
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      refreshPage()
    }
    dispatch(setIsSaveButtonLoadingAction(false))
  }

  const enterModify = () => {
    history.push({
      pathname: '/srm/editFinancialreconciliation',
      state: {
        data: detailInfo?.orderInfoList.map((item) => ({
          ...item,
          customerInvoice: item.orderInvoiceStatus,
          returnState: item.customerPayback,
          type: 'origin',
        })),
        id: detailInfo?.id,
        rejectReason: detailInfo?.groundsForRejection,
        remark: detailInfo?.supplierRemark,
      },
    })
  }

  // 导出寄票随单
  const exrpotInvoiceWidthOrder = () => {
    POST_DOWNLOAD_ACCOUNT_ACCEPT_TEMP([detailInfo?.id || ''])
  }

  // 批量导入发票-上传文件
  const uploadFlag = useRef<number>(0)

  // 1.上传之前处理文件
  const beforeUpload = (file: RcFile, FileList: RcFile[]) => {
    const reg = generateRegExp(FINANCIAL_INVOICE_FILE_TYPE)
    const index = file.name.search(reg)
    if (FileList.length > 10) {
      message.error('上传失败：文件数量超出限制（10个）')
      uploadFlag.current = 0
      return false
    }
    if (file.size > 1024 * 1024 * 20) {
      message.error('请勿上传超过20m的文件！')
      uploadFlag.current = 0
      return false
    }
    if (index === -1) {
      // 限制上传文件格式
      message.error('请上传正确的文件格式！')
      uploadFlag.current = 0
      return false
    }
    uploadFlag.current++
    if (uploadFlag.current === FileList.length) {
      uploadfile(FileList)
      uploadFlag.current = 0
    }
    return false
  }

  // 2.调用接口上传文件
  const uploadfile = async (FileList: RcFile[]) => {
    changeBatchModalVisible(true, 'batchUpload')
    dispatch(setBatchUploadLoadingAction(true))
    const res = await UPLOAD_FILES({ type: 'invoice' }, FileList)
    if (isResponseCodeSuccess(res.code)) {
      await recognizeInvoice(
        res.data.map((item: any) => ({ url: item.url, fileId: item.id })),
      )
      dispatch(setBatchUploadLoadingAction(false))
    }
  }

  // 3.识别发票
  const recognizeInvoice = async (params: RecognizeInvoiceParams[]) => {
    const fileUrls = params.map((item) => item.url).join(',')
    const res = await POST_RECOGNIZE_INVOICE({ fileUrls })
    if (isResponseCodeSuccess(res.code)) {
      const invoiceList = res.data.map((item) => ({
        ...item,
        invoiceTime: item.invoiceTime ? moment(Number(item.invoiceTime)) : null,
        fileList: [
          {
            url: item.url,
            baseUrl: item.baseUrl,
            name: getPicName(item.url),
            id: item.fileId,
          },
        ],
      }))
      invoiceForm.setFieldsValue({
        invoiceList,
      })
      message.success(res.msg)
    }
  }

  const onBatchModalSubmit = async () => {
    const formData = await invoiceForm.validateFields()
    const invoiceList: InvoiceParams[] = formData['invoiceList']
    dispatch(
      setTicketInfoListAction([
        ...ticketInfoList,
        ...invoiceList.map((item) => ({
          ...item,
          invoiceTime: item.invoiceTime?.valueOf(),
          fileList: item.fileList ?? [],
          accountInvoiceId: generateRandomId(),
          logisticsCompany: formData['logisticsCompany'],
          logisticsNum: formData['logisticsNum'],
        })),
      ]),
    )
    changeBatchModalVisible(false)
  }

  const changeBatchModalVisible = (
    val: boolean,
    type?: FinanicialInvoiceType,
  ) => {
    dispatch(setInvoiceBatchModalVisibleAction(val))
    type && dispatch(setFinanicialInvoiceTypeAction(type))
  }

  // 复制
  const onCopy = (type: 'email' | 'address') => {
    let template = ''
    let msgTitle = ''
    switch (type) {
      case 'email':
        template = 'czk0529@xianhengguoji.com'
        msgTitle = '电票收票邮箱'
        break
      case 'address':
        template =
          '王亚，17855973107，浙江省嘉兴市海宁市启辉路16号1号楼6楼财务室'
        msgTitle = '线下寄票地址'
        break
    }
    copy(template)
    message.success(`复制${msgTitle}成功`)
  }

  return {
    form,
    isAddModalVisible,
    state,
    invoiceForm,
    changeBatchModalVisible,
    onBatchModalSubmit,
    handleCheckedChange,
    handlePaginationChange,
    handleTableChangeCheck,
    handleAddOrderModalCancel,
    handleSumitSuccess,
    onPackageDownload,
    showPreviewModal,
    cancelPreviewModal,
    handleDelTicket,
    handleSaveTicket,
    handleEditTicket,
    enterModify,
    exrpotInvoiceWidthOrder,
    beforeUpload,
    onCopy,
  }
}
import { Form, message } from 'antd'
import { RcFile } from 'antd/lib/upload'
import React, { useEffect, useReducer, useRef, useState } from 'react'
import {
  GET_ACCOUNT_DETAIL,
  AccountDetailRes,
  DOWNLOAD_ZIP_MORE,
  InvoiceParams,
  OrderAccountInvoiceInfoList,
  ACCOUNT_OPEN_INVOICE,
  POST_RECOGNIZE_INVOICE,
  RecognizeInvoiceParams,
  POST_DOWNLOAD_ACCOUNT_ACCEPT_TEMP,
  UPLOAD_FILES,
} from '../../api/orderManage'
import { fileFile } from '../../modules/uploadfiles/hooks'
import {
  accountOpenInvoiceStateDictInvert,
  accountStatusDictInvert,
  signVoucherStateDict,
} from '../../tools/state'
import {
  isResponseCodeSuccess,
  formatTime,
  generateRegExp,
  getPicName,
  generateRandomId,
} from '../../tools/util'
import { useQuery } from '../../tools/utilHooks'
import { produce } from 'immer'
import { history } from '../../redux/store'
import { FinanicialInvoiceType } from './components/financialTicketBatchModal'
import { FINANCIAL_INVOICE_FILE_TYPE } from '.'
import moment from 'moment'
import copy from 'copy-to-clipboard'

export type tabKey = '物料明细' | '订单明细' | '回款明细'

interface paginationOption {
  total: number
  current: number
  pagesize: number
}

interface State {
  checkedRadioKey: tabKey // 当前选中tab的key值
  isTableLoading?: boolean
  detailInfo?: AccountDetailRes
  orderDetail: any // 订单明细
  productDetail: any // 物料明细
  returnDetail: any // 回款明细
  dataSource: any[]
  pagination: paginationOption
  selectedRows: any[]
  invoiceData: any[] // 开票信息
  isPreviewModalVisible: boolean
  previewFileUrl: string
  ticketInfoList: InvoiceParams[]
  editIndex: number
  isSaveButtonLoading: boolean
  invoiceBatchModalVisible: boolean
  finanicialInvoiceType: FinanicialInvoiceType
  batchUploadLoading: boolean
}
type ActionType =
  | 'setCurrentRadioDict'
  | 'setCheckedRadioKey'
  | 'setIsTableLoading'
  | 'setDetailInfo'
  | 'setOrderDetail'
  | 'setProductDetail'
  | 'setReturnDetail'
  | 'setDataSource'
  | 'setPagination'
  | 'setSelectedRows'
  | 'setInvoiceData'
  | 'setIsPreviewModalVisible'
  | 'setPreviewFileUrlUrl'
  | 'setTicketInfoListAction'
  | 'setEditIndexAction'
  | 'setIsSaveButtonLoadingAction'
  | 'setInvoiceBatchModalVisibleAction'
  | 'setFinanicialInvoiceTypeAction'
  | 'setBatchUploadLoadingAction'

interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  checkedRadioKey: '订单明细',
  isTableLoading: false,
  detailInfo: undefined,
  orderDetail: undefined,
  productDetail: undefined,
  returnDetail: undefined,
  dataSource: [],
  pagination: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  selectedRows: [],
  invoiceData: [],
  isPreviewModalVisible: false,
  previewFileUrl: '',
  ticketInfoList: [],
  editIndex: -1,
  isSaveButtonLoading: false,
  invoiceBatchModalVisible: false,
  finanicialInvoiceType: 'batchUpload',
  batchUploadLoading: false,
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setCheckedRadioKey':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setDetailInfo':
      newstate.detailInfo = action.payload
      return newstate
    case 'setOrderDetail':
      newstate.orderDetail = action.payload
      return newstate
    case 'setProductDetail':
      newstate.productDetail = action.payload
      return newstate
    case 'setReturnDetail':
      newstate.returnDetail = action.payload
      return newstate
    case 'setDataSource':
      newstate.dataSource = action.payload
      return newstate
    case 'setPagination':
      newstate.pagination = action.payload
      return newstate
    case 'setSelectedRows':
      newstate.selectedRows = action.payload
      return newstate
    case 'setInvoiceData':
      newstate.invoiceData = action.payload
      return newstate
    case 'setIsPreviewModalVisible':
      newstate.isPreviewModalVisible = action.payload
      return newstate
    case 'setPreviewFileUrlUrl':
      newstate.previewFileUrl = action.payload
      return newstate
    case 'setTicketInfoListAction':
      newstate.ticketInfoList = action.payload
      return newstate
    case 'setEditIndexAction':
      newstate.editIndex = action.payload
      return newstate
    case 'setIsSaveButtonLoadingAction':
      newstate.isSaveButtonLoading = action.payload
      return newstate
    case 'setInvoiceBatchModalVisibleAction':
      newstate.invoiceBatchModalVisible = action.payload
      return newstate
    case 'setFinanicialInvoiceTypeAction':
      newstate.finanicialInvoiceType = action.payload
      return newstate
    case 'setBatchUploadLoadingAction':
      newstate.batchUploadLoading = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
const setCheckedRadioKey = (val: React.Key): Action => ({
  type: 'setCheckedRadioKey',
  payload: val,
})
/**
 * 设置详情页信息对象
 */
const setDetailInfo = (val: any): Action => ({
  type: 'setDetailInfo',
  payload: val,
})

const setTicketInfoListAction = (val: InvoiceParams[]): Action => ({
  type: 'setTicketInfoListAction',
  payload: val,
})

const setEditIndexAction = (val: number): Action => ({
  type: 'setEditIndexAction',
  payload: val,
})

const setIsSaveButtonLoadingAction = (val: boolean): Action => ({
  type: 'setIsSaveButtonLoadingAction',
  payload: val,
})

/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
const setPagination = (val: paginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

/**
 * 设置选中的行的信息列表
 * @param val
 * @returns
 */
const setSelectedRows = (val: any): Action => ({
  type: 'setSelectedRows',
  payload: val,
})

// 预览弹窗
const setIsPreviewModalVisible = (val: boolean): Action => ({
  type: 'setIsPreviewModalVisible',
  payload: val,
})

// 预览文件url
const setPreviewFileUrlUrl = (val: string): Action => ({
  type: 'setPreviewFileUrlUrl',
  payload: val,
})

// 上传发票
const setInvoiceBatchModalVisibleAction = (val: boolean): Action => ({
  type: 'setInvoiceBatchModalVisibleAction',
  payload: val,
})

// 上传发票
const setFinanicialInvoiceTypeAction = (
  val: FinanicialInvoiceType,
): Action => ({
  type: 'setFinanicialInvoiceTypeAction',
  payload: val,
})

// 批量上传loading
const setBatchUploadLoadingAction = (val: boolean): Action => ({
  type: 'setBatchUploadLoadingAction',
  payload: val,
})

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { detailInfo, pagination, ticketInfoList } = state
  const query = useQuery()
  const id = query.get('id') || ''
  const [form] = Form.useForm()
  const [invoiceForm] = Form.useForm()
  const [isAddModalVisible, setIsAddModalVisible] = useState(false)

  const handleCheckedChange = (key: any) => {
    dispatch(setCheckedRadioKey(key))
  }
  const handleTableChangeCheck = (
    selectedRowKeys: any,
    selectedRows: any[],
  ) => {
    dispatch(setSelectedRows(selectedRows))
  }

  function convertAccountDetailState(detail: AccountDetailRes) {
    return {
      ...detail,
      accountStatus: accountStatusDictInvert?.[detail?.accountStatus]?.name,
      // @ts-ignore
      commitTime: formatTime(detail?.commitTime + '' ?? ''),
      confirmTime: formatTime(detail?.confirmTime ?? ''),
      // @ts-ignore
      createTime: formatTime(detail?.createTime + '' ?? ''),
      accountOpenInvoiceStatus:
        accountOpenInvoiceStateDictInvert?.[detail?.accountOpenInvoiceStatus]
          ?.name,

      orderInfoList: detail?.orderInfoList?.map((item) => {
        return {
          ...item,
          id: item.orderId,
          // @ts-ignore
          orderTime: formatTime(item.orderTime + '' ?? ''),
          signVoucherState: (signVoucherStateDict as any)?.[
            item?.signVoucherState
          ],
        }
      }),
    }
  }
  function convertToInvoiceParam(
    list: OrderAccountInvoiceInfoList[],
  ): InvoiceParams[] {
    return list.map((item) => {
      return {
        ...item,
        fileIdList: item.fileList.map((item) => item.id),
        invoiceId: item.accountInvoiceId,
      }
    })
  }
  const getDetailInfo = async () => {
    const res = await GET_ACCOUNT_DETAIL({
      accountId: id,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = convertAccountDetailState(res.data)
      dispatch(setDetailInfo(resData))
      dispatch(
        setTicketInfoListAction(
          convertToInvoiceParam(resData.orderAccountInvoiceInfoList),
        ),
      )
      form.setFieldsValue({
        ...res.data,
      })
    } else {
      message.warning(res.msg)
    }
  }

  function handlePaginationChange(page: number, pageSize?: number) {
    dispatch(
      setPagination({
        ...pagination,
        pagesize: pageSize ? pageSize : pagination.pagesize,
        current: page,
      }),
    )
  }

  const handleAddOrderModalCancel = () => {
    setIsAddModalVisible(false)
  }

  async function refreshPage() {
    getDetailInfo()
  }
  useEffect(() => {
    if (id) {
      getDetailInfo()
    }
    // eslint-disable-next-line
  }, [])

  const handleSumitSuccess = (param: InvoiceParams, index: number) => {
    handleAddOrderModalCancel()
    // getDetailInfo()
    if (index < 0) {
      dispatch(setTicketInfoListAction([...ticketInfoList, param]))
    } else {
      const newState = produce(ticketInfoList, (draftState) => {
        draftState[index] = param
      })
      dispatch(setTicketInfoListAction(newState))
    }
  }

  // 打包下载附件
  const onPackageDownload = async (files: fileFile[]) => {
    await DOWNLOAD_ZIP_MORE({
      fileIdList: files.map((item) => item.id!),
    })
  }

  const cancelPreviewModal = () => {
    dispatch(setIsPreviewModalVisible(false))
  }

  const showPreviewModal = (url: string) => {
    dispatch(setPreviewFileUrlUrl(url))
    dispatch(setIsPreviewModalVisible(true))
  }
  const handleDelTicket = (index: number) => {
    if (index > ticketInfoList.length - 1) {
      return
    }
    const afterDeleted = produce(ticketInfoList, (draftState) => {
      draftState.splice(index, 1)
    })
    dispatch(setTicketInfoListAction(afterDeleted))
  }
  const handleEditTicket = (index: number) => {
    dispatch(setEditIndexAction(index))
    setIsAddModalVisible(true)
  }
  async function handleSaveTicket() {
    if (ticketInfoList.length < 1) {
      message.warning('没有任何发票信息')
      return
    }
    const savedIds: string[] = []
    const savedFileIdsSet = new Set<string>()
    ticketInfoList.forEach((item) => {
      if (item.invoiceId) {
        savedIds.push(item.invoiceId)
      }
      if (item.fileIdList) {
        item.fileIdList.forEach((item) => {
          savedFileIdsSet.add(item)
        })
      }
    })
    const deletedIds = detailInfo?.orderAccountInvoiceInfoList
      .filter((item) => {
        return !savedIds.includes(item.accountInvoiceId)
      })
      .map((item) => item.accountInvoiceId)

    const deletedFileIdsSet = new Set<string>()
    detailInfo?.orderAccountInvoiceInfoList.forEach((item) => {
      item.fileList.forEach((fileItem) => {
        if (!savedFileIdsSet.has(fileItem.id)) {
          deletedFileIdsSet.add(fileItem.id)
        }
      })
    })
    dispatch(setIsSaveButtonLoadingAction(true))
    const res = await ACCOUNT_OPEN_INVOICE({
      deletedFileIds: Array.from(deletedFileIdsSet),
      deletedIds: deletedIds,
      invoiceParams: ticketInfoList.map((item) => {
        return {
          ...item,
          fileIdList: item.fileList.map((item) => item.id),
        }
      }),
      orderAccountId: detailInfo?.id ?? '',
    })
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      refreshPage()
    }
    dispatch(setIsSaveButtonLoadingAction(false))
  }

  const enterModify = () => {
    history.push({
      pathname: '/srm/editFinancialreconciliation',
      state: {
        data: detailInfo?.orderInfoList.map((item) => ({
          ...item,
          customerInvoice: item.orderInvoiceStatus,
          returnState: item.customerPayback,
          type: 'origin',
        })),
        id: detailInfo?.id,
        rejectReason: detailInfo?.groundsForRejection,
        remark: detailInfo?.supplierRemark,
      },
    })
  }

  // 导出寄票随单
  const exrpotInvoiceWidthOrder = () => {
    POST_DOWNLOAD_ACCOUNT_ACCEPT_TEMP([detailInfo?.id || ''])
  }

  // 批量导入发票-上传文件
  const uploadFlag = useRef<number>(0)

  // 1.上传之前处理文件
  const beforeUpload = (file: RcFile, FileList: RcFile[]) => {
    const reg = generateRegExp(FINANCIAL_INVOICE_FILE_TYPE)
    const index = file.name.search(reg)
    if (FileList.length > 10) {
      message.error('上传失败：文件数量超出限制（10个）')
      uploadFlag.current = 0
      return false
    }
    if (file.size > 1024 * 1024 * 20) {
      message.error('请勿上传超过20m的文件！')
      uploadFlag.current = 0
      return false
    }
    if (index === -1) {
      // 限制上传文件格式
      message.error('请上传正确的文件格式！')
      uploadFlag.current = 0
      return false
    }
    uploadFlag.current++
    if (uploadFlag.current === FileList.length) {
      uploadfile(FileList)
      uploadFlag.current = 0
    }
    return false
  }

  // 2.调用接口上传文件
  const uploadfile = async (FileList: RcFile[]) => {
    changeBatchModalVisible(true, 'batchUpload')
    dispatch(setBatchUploadLoadingAction(true))
    const res = await UPLOAD_FILES({ type: 'invoice' }, FileList)
    if (isResponseCodeSuccess(res.code)) {
      await recognizeInvoice(
        res.data.map((item: any) => ({ url: item.url, fileId: item.id })),
      )
      dispatch(setBatchUploadLoadingAction(false))
    }
  }

  // 3.识别发票
  const recognizeInvoice = async (params: RecognizeInvoiceParams[]) => {
    const fileUrls = params.map((item) => item.url).join(',')
    const res = await POST_RECOGNIZE_INVOICE({ fileUrls })
    if (isResponseCodeSuccess(res.code)) {
      const invoiceList = res.data.map((item) => ({
        ...item,
        invoiceTime: item.invoiceTime ? moment(Number(item.invoiceTime)) : null,
        fileList: [
          {
            url: item.url,
            baseUrl: item.baseUrl,
            name: getPicName(item.url),
            id: item.fileId,
          },
        ],
      }))
      invoiceForm.setFieldsValue({
        invoiceList,
      })
      message.success(res.msg)
    }
  }

  const onBatchModalSubmit = async () => {
    const formData = await invoiceForm.validateFields()
    const invoiceList: InvoiceParams[] = formData['invoiceList']
    dispatch(
      setTicketInfoListAction([
        ...ticketInfoList,
        ...invoiceList.map((item) => ({
          ...item,
          invoiceTime: item.invoiceTime?.valueOf(),
          fileList: item.fileList ?? [],
          accountInvoiceId: generateRandomId(),
          logisticsCompany: formData['logisticsCompany'],
          logisticsNum: formData['logisticsNum'],
        })),
      ]),
    )
    changeBatchModalVisible(false)
  }

  const changeBatchModalVisible = (
    val: boolean,
    type?: FinanicialInvoiceType,
  ) => {
    dispatch(setInvoiceBatchModalVisibleAction(val))
    type && dispatch(setFinanicialInvoiceTypeAction(type))
  }

  // 复制
  const onCopy = (type: 'email' | 'address') => {
    let template = ''
    let msgTitle = ''
    switch (type) {
      case 'email':
        template = 'czk0529@xianhengguoji.com'
        msgTitle = '电票收票邮箱'
        break
      case 'address':
        template =
          '王亚，17855973107，浙江省嘉兴市海宁市启辉路16号1号楼6楼财务室'
        msgTitle = '线下寄票地址'
        break
    }
    copy(template)
    message.success(`复制${msgTitle}成功`)
  }

  return {
    form,
    isAddModalVisible,
    state,
    invoiceForm,
    changeBatchModalVisible,
    onBatchModalSubmit,
    handleCheckedChange,
    handlePaginationChange,
    handleTableChangeCheck,
    handleAddOrderModalCancel,
    handleSumitSuccess,
    onPackageDownload,
    showPreviewModal,
    cancelPreviewModal,
    handleDelTicket,
    handleSaveTicket,
    handleEditTicket,
    enterModify,
    exrpotInvoiceWidthOrder,
    beforeUpload,
    onCopy,
  }
}
